module.exports = __webpack_public_path__ + "img/head_title.46f64522.png";